import { ReactNode } from 'react';

export interface IUpsellRule {
    upsellRuleID: number;
    pluginQuantity: number;
    value: number;
}

export interface IUpsellExcludedProduct {
    skuid: number;
}

export interface IUpsellBoxStatus {
    isVisible: boolean;
    result?: IUpsellTypeResult|null;
}

export interface IUpsellTypeResult {
    isVisible: boolean;
    upsellType: number;
    isAboveMaxTier: boolean;
    add?: number;
    productsQty?: number;
    discount?: number;
    progressBar?: IUpsellProgressBar;
    text?: ReactNode;
    productsCount: number;
}

export interface IUpsellProgressBar {
    min: number;
    max: number;
    value: number;
    ariaText: string;
    percent: number;
    userValue: number;
}

export enum UpSellTypeEnum
{
    PercentDiscount = 1,
    FixedPrice = 2,
    ProgressiveDiscount = 3,
    TotalFixed = 4,
    TotalPercent = 5
}

export enum UpsellReferrer {
    CartStep1 = 1,
    CartStep2 = 2,
    CartStep3 = 3,
    TopMiniCart = 4,
    AddToCartPopup = 5,
}